module.exports = __webpack_public_path__ + "img/skate-you-did-it.53b37a6a.png";